import { render, staticRenderFns } from "./InstallCCTVApp.vue?vue&type=template&id=06e1bef3&scoped=true&"
import script from "./InstallCCTVApp.vue?vue&type=script&lang=js&"
export * from "./InstallCCTVApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e1bef3",
  null
  
)

export default component.exports